// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font: 600 0.95rem/1.2 "Almendra", serif;
  border-radius: 11px;
  border: 1px solid transparent;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-decoration: none;
  transition: transform 0.06s ease, opacity 0.2s ease, background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  color: #0b0b0c;
  background: transparent;
}
.ui-btn:active {
  transform: translateY(1px);
}
.ui-btn:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 4px #c4b5fd;
}
.ui-btn--sm {
  height: 2.25rem;
  padding: 0 0.9rem;
  font-size: 0.9rem;
}
.ui-btn--md {
  height: 2.75rem;
  padding: 0 1.1rem;
}
.ui-btn--lg {
  height: 3.1rem;
  padding: 0 1.3rem;
  font-size: 1.05rem;
}
.ui-btn--primary {
  background: #926F34;
  color: #fffcf2;
}
.ui-btn--primary:hover {
  opacity: 0.95;
}
.ui-btn--outline {
  background: #fff;
  border-color: #e5e7eb;
}
.ui-btn--outline:hover {
  background: #f3f4f6;
}
.ui-btn--ghost {
  background: transparent;
}
.ui-btn--ghost:hover {
  background: #f3f4f6;
}
.ui-btn--link {
  background: transparent;
  color: #4f46e5;
  border: 0;
  padding: 0;
  height: auto;
}
.ui-btn--link:hover {
  text-decoration: underline;
}
.ui-btn--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.ui-btn__label {
  display: inline-block;
}
.ui-btn__icon {
  display: inline-flex;
}
.ui-btn__icon--left {
  margin-right: 0.25rem;
}
.ui-btn__icon--right {
  margin-left: 0.25rem;
}
.ui-btn__spinner {
  width: 1rem;
  height: 1rem;
  border: 0.15rem solid #6b7280;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ui-spin 0.8s linear infinite;
}

@keyframes ui-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/ButtonComponent/ButtonComponent.scss","webpack://./src/styles/_tokens.scss"],"names":[],"mappings":"AAgCA;EAxBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uCAAA;EACA,mBCVW;EDWX,6BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,wIACE;EAMF,cClBW;EDmBX,uBAAA;AAZF;AAcE;EAAW,0BAAA;AAXb;AAYE;EA1BA,UAAA;EACA,6BAAA;AAiBF;AAcE;EAAQ,eCrBH;EDqBkB,iBCjBhB;EDiBkC,iBAAA;AAT3C;AAUE;EAAQ,eCrBH;EDqBkB,iBCjBhB;ADWT;AAOE;EAAQ,cCrBH;EDqBkB,iBCjBhB;EDiBkC,kBAAA;AAF3C;AAIE;EACE,mBCnCY;EDoCZ,cCnCe;ADiCnB;AAII;EAAU,aAAA;AADd;AAIE;EACE,gBAAA;EACA,qBCvCW;ADqCf;AAII;EAAU,mBCxCE;ADuChB;AAIE;EACE,uBAAA;AAFJ;AAII;EAAU,mBC9CE;AD6ChB;AAIE;EACE,uBAAA;EACA,cClDS;EDmDT,SAAA;EACA,UAAA;EACA,YAAA;AAFJ;AAII;EAAU,0BAAA;AADd;AAIE;EACE,YAAA;EACA,mBAAA;AAFJ;AAKE;EAAW,qBAAA;AAFb;AAGE;EAAU,oBAAA;AAAZ;AACE;EAAgB,qBAAA;AAElB;AADE;EAAiB,oBAAA;AAInB;AAFE;EACE,WAAA;EAAa,YAAA;EACb,6BAAA;EACA,6BAAA;EACA,kBAAA;EACA,uCAAA;AAKJ;;AADA;EAAqB;IAAK,yBAAA;EAMxB;AACF","sourcesContent":["@use \"../styles/tokens\" as *;  // ✅ from src/ButtonComponent to src/styles\r\n\r\n@mixin focus-ring {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 4px $color-ring;\r\n}\r\n\r\n@mixin btn-reset {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: .5rem;\r\n  font: 600 .95rem/1.2 $btn-font;\r\n  border-radius: $btn-radius;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  text-decoration: none;\r\n  transition:\r\n    transform .06s ease,\r\n    opacity .2s ease,\r\n    background .2s ease,\r\n    color .2s ease,\r\n    border-color .2s ease,\r\n    box-shadow .2s ease;\r\n  color: $color-text;\r\n  background: transparent;\r\n\r\n  &:active { transform: translateY(1px); }\r\n  &:focus-visible { @include focus-ring; }\r\n}\r\n\r\n.ui-btn {\r\n  @include btn-reset;\r\n\r\n  &--sm { height: $h-sm; padding: $pad-sm; font-size: .9rem; }\r\n  &--md { height: $h-md; padding: $pad-md; }\r\n  &--lg { height: $h-lg; padding: $pad-lg; font-size: 1.05rem; }\r\n\r\n  &--primary {\r\n    background: $color-primary;\r\n    color: $color-on-primary;\r\n\r\n    &:hover { opacity: .95; }\r\n  }\r\n\r\n  &--outline {\r\n    background: #fff;\r\n    border-color: $color-border;\r\n\r\n    &:hover { background: $color-surface; }\r\n  }\r\n\r\n  &--ghost {\r\n    background: transparent;\r\n\r\n    &:hover { background: $color-surface; }\r\n  }\r\n\r\n  &--link {\r\n    background: transparent;\r\n    color: $color-link;\r\n    border: 0;\r\n    padding: 0;\r\n    height: auto;\r\n\r\n    &:hover { text-decoration: underline; }\r\n  }\r\n\r\n  &--disabled {\r\n    opacity: .6;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n  &__label { display: inline-block; }\r\n  &__icon { display: inline-flex; }\r\n  &__icon--left { margin-right: .25rem; }\r\n  &__icon--right { margin-left: .25rem; }\r\n\r\n  &__spinner {\r\n    width: 1rem; height: 1rem;\r\n    border: .15rem solid $color-muted;\r\n    border-top-color: transparent;\r\n    border-radius: 50%;\r\n    animation: ui-spin .8s linear infinite;\r\n  }\r\n}\r\n\r\n@keyframes ui-spin { to { transform: rotate(360deg); } }\r\n","// src/styles/_tokens.scss\r\n$btn-font: \"Almendra\", serif !default; // <-- use Almendra here\r\n\r\n$btn-radius: 11px;\r\n\r\n$color-primary: #926F34 !default; //#DFBD69\r\n$color-on-primary: #fffcf2 !default;\r\n$color-text: #0b0b0c !default;\r\n$color-muted: #6b7280 !default;\r\n$color-border: #e5e7eb !default;\r\n$color-surface: #f3f4f6 !default;\r\n$color-link: #4f46e5 !default;\r\n$color-ring: #c4b5fd !default;\r\n\r\n$h-sm: 2.25rem !default;\r\n$h-md: 2.75rem !default;\r\n$h-lg: 3.10rem !default;\r\n\r\n$pad-sm: 0 0.9rem !default;\r\n$pad-md: 0 1.1rem !default;\r\n$pad-lg: 0 1.3rem !default;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
